import { render, staticRenderFns } from "./filesconfig.vue?vue&type=template&id=4431f604&scoped=true&"
import script from "./filesconfig.vue?vue&type=script&lang=js&"
export * from "./filesconfig.vue?vue&type=script&lang=js&"
import style0 from "./filesconfig.vue?vue&type=style&index=0&id=4431f604&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4431f604",
  null
  
)

export default component.exports